import ProfessionalServices from "@/services/ProfessionalServices";
import ProfessionalRequest from "@/model/requests/ProfessionalRequest";
import LoaderUtils from "@/utils/BaseUtils/LoaderUtils";
import StoreUtils from "@/utils/BaseUtils/StoreUtils";
import ReviewRequest from "@/model/requests/ReviewRequest";
import Utils from "@/utils/Utils";
const professionalService = new ProfessionalServices();

export const namespaced = true;

export const state = {
  categories: {},
  experienceLevels: [],
  professionalSuccess: false,
  profEnrol: false,
  professionalId: "",
  professionalInfo: {},
  professionals: [],
  professionalsDisplay: [],
  singleProfessional: {},
  updateSuccess: true,
  page: 1,
  slots: [],
  profSubscriptions: {},
  reviews: [],
  customerToProfessionalId: ""
};

export const getters = {
  getCategories: state => {
    return state.categories;
  },
  getExperienceLevels: state => {
    return state.experienceLevels;
  },
  getProfessionalSuccess: state => {
    return state.professionalSuccess;
  },
  getProfEnrol: state => {
    return state.profEnrol;
  },
  getProfessionalId: state => {
    return state.professionalId;
  },
  getProfessionalInfo: state => {
    return state.professionalInfo;
  },
  getProfessionals: state => {
    return state.professionals;
  },
  getSingleProfessional: state => {
    return state.singleProfessional;
  },
  getProfessionalsDisplay: state => {
    return state.professionalsDisplay;
  },
  getUpdateSuccess: state => {
    return state.updateSuccess;
  },
  getPage: state => {
    return state.page;
  },
  getSlots: state => {
    return state.slots;
  },
  getCustomerToProfessionalId: state => {
    return state.customerToProfessionalId;
  }
};

export const mutations = {
  updateCategories: (state, payload) => {
    state.categories = payload;
  },
  updateExperienceLevels: (state, payload) => {
    state.experienceLevels = payload;
  },
  updateProfessionalSuccess: (state, payload) => {
    state.professionalSuccess = payload;
  },
  updateProfessionalEnrol: (state, payload) => {
    state.profEnrol = payload;
  },
  updateProfessionalId: (state, payload) => {
    state.professionalId = payload;
  },
  updateProfessionalInfo: (state, payload) => {
    state.professionalInfo = payload;
  },
  updateProfessionals: (state, payload) => {
    state.professionals = payload;
  },
  updateSingleProfessional: (state, payload) => {
    state.singleProfessional = payload;
  },
  updateProfessionalsDisplay: (state, payload) => {
    state.professionalsDisplay = payload;
  },
  updateUpdateSuccess: (state, payload) => {
    state.updateSuccess = payload;
  },
  updatePage: (state, payload) => {
    state.page = payload;
  },
  updateSlots: (state, payload) => {
    state.slots = payload;
  },
  updateProfSubscriptions: (state, payload) => {
    state.profSubscriptions = payload;
  },
  updateReviews: (state, payload) => {
    state.reviews = payload;
  },
  updateCustomerToProfessionalId: (state, payload) => {
    state.customerToProfessionalId = payload;
  }
};

export const actions = {
  createProfessional({ commit }, payload = ProfessionalRequest.create) {
    let successAction = responseData => {
      Utils.saveToLocalStorage("token", responseData.token);
      commit("updateProfessionalEnrol", false);
      commit("updateProfessionalSuccess", true);
      commit("updateProfessionalId", responseData.professionalId);
      commit("updateCustomerToProfessionalId", responseData.professionalId);
      let professional = { professionalId: responseData.professionalId };
      StoreUtils.dispatch("professional/readByProfessionalId", professional);
    };
    return professionalService.createProfessional(
      payload,
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },
  fetchCategories({ commit }) {
    let successAction = responseData => {
      commit("updateCategories", responseData.data);
    };
    return professionalService.fetchCategory(
      {},
      successAction,
      LoaderUtils.types.NONE
    );
  },
  fetchExperienceLevels({ commit }) {
    let successAction = responseData => {
      commit("updateExperienceLevels", responseData.data);
    };
    return professionalService.fetchExperienceLevel(
      {},
      successAction,
      LoaderUtils.types.NONE
    );
  },
  readByProfessionalId({ commit }, payload = ProfessionalRequest.readBy) {
    let successAction = responseData => {
      commit("updateProfessionalInfo", responseData.data);
      commit("updateSingleProfessional", responseData.data);
    };
    return professionalService.readByProfessional(
      payload,
      successAction,
      LoaderUtils.types.NONE
    );
  },
  readProfessionals({ commit }) {
    let successAction = responseData => {
      commit("updateProfessionals", responseData.data);
      commit("updateProfessionalsDisplay", responseData.data.slice(0, 8));
    };
    return professionalService.readProfessional(
      {},
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },
  updateProfessional({ commit }, payload = ProfessionalRequest.update) {
    let successAction = () => {
      let professionalId;
      if ("professional" in StoreUtils.rootGetters("auth/getUserInfo")) {
        professionalId = StoreUtils.rootGetters("auth/getUserInfo").professional
          .professionalId;
      } else {
        professionalId = StoreUtils.rootGetters(
          "professional/getCustomerToProfessionalId"
        );
      }
      StoreUtils.dispatch("professional/readByProfessionalId", {
        professionalId
      });
      commit("updateUpdateSuccess", false);
    };
    return professionalService.updateProfessional(
      payload,
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },
  searchProfessional({ state, commit }, payload = ProfessionalRequest.search) {
    let professionals = [...state.professionalsDisplay];
    let successAction = responseData => {
      commit("updateProfessionalsDisplay", responseData.data);
      if (payload.page > 1) {
        let pageProfessionals = professionals.concat(responseData.data);
        commit("updateProfessionalsDisplay", pageProfessionals);
      }
    };
    return professionalService.searchProfessional(
      payload,
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },
  readByReference({ commit }, payload = ProfessionalRequest.readReference) {
    let successAction = responseData => {
      commit("updateSingleProfessional", responseData.data);
    };

    return professionalService.readReference(
      payload,
      successAction,
      LoaderUtils.types.NONE
    );
  },
  readSubscriptionPlans(
    { commit },
    payload = ProfessionalRequest.readSubscriptionPlans
  ) {
    let successAction = responseData => {
      commit("updateProfSubscriptions", responseData);
    };

    return professionalService.readSubscriptionPlans(
      payload,
      successAction,
      LoaderUtils.types.NONE
    );
  },
  updateSubscriptionPlans(
    { commit },
    payload = ProfessionalRequest.updateSubscriptionPlans
  ) {
    let successAction = () => {
      let subscriptionPlanProfessionalId = StoreUtils.rootGetters(
        "auth/getUserInfo"
      ).professional.professionalId;
      StoreUtils.dispatch("professional/readSubscriptionPlans", {
        subscriptionPlanProfessionalId
      });
    };

    return professionalService.updateSubscriptionPlans(
      payload,
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },
  readReviews({ commit }, payload = ReviewRequest.readByProfessionalId) {
    let successAction = responseData => {
      commit("updateReviews", responseData.data);
    };
    return professionalService.readReviews(
      payload,
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  }
};
